import clsx from 'clsx';
import style from '../aboutObject/styles.module.scss';

interface IAboutObjectEstimateMarketPriceProps {
  minFacilityPrice: string;
  marketPrice: string;
  maxFacilityPrice: string;
}

export const AboutObjectEstimateMarketPrice = ({
  minFacilityPrice,
  marketPrice,
  maxFacilityPrice,
}: IAboutObjectEstimateMarketPriceProps) => {
  return (
    <div className={clsx(style.marketPrice__container)}>
      <h4 className={clsx(style.marketPrice__title, style.marketPrice__title_big)}>
        Коридор рыночной стоимости
      </h4>

      <div className={style.marketPrice__row}>
        <div className={style.marketPrice__start}>
          <div className={style.marketPrice__startText}>
            <span>от</span>
            <span>{` ${minFacilityPrice}`}</span>
          </div>
        </div>

        <div className={style.marketPrice__mid}>
          <div className={style.marketPrice__midContainer}>
            <div className={style.marketPrice__midUp} />

            <div className={style.marketPrice__midText}>
              <span>{`${marketPrice}`}</span>
            </div>
          </div>
        </div>

        <div className={style.marketPrice__end}>
          <div className={style.marketPrice__endText}>
            <span>до</span>
            <span>{` ${maxFacilityPrice}`}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
